import { User } from 'panel/user/redux/types'
import { AlertActionTypes } from 'util/modules/Alert/redux/types'

/**
* Data Types
*/

export type PartnerStaffType = 'OWNER'|'MANAGER'|'DELIVERYMAN'|'COOKER'|'CLERK'

export interface PartnerStaff {
  id: number,
  role: PartnerStaffType,
  user: Partial<User>
}

export interface PartnerStaffData {
  user: number,
  role: PartnerStaffType,
}

/**
* State Type
*/

export interface PartnerStaffState {
  readonly staff: PartnerStaff[]
  readonly labels: { [x: string]: string }
}

/**
* Action Enum Types
*/

export enum PartnerStaffTypes {
  PARTNER_STAFF_CREATE = 'PARTNER/STAFF/CREATE',
  PARTNER_STAFF_DELETE = 'PARTNER/STAFF/DELETE',
  PARTNER_STAFF_GET_LIST = 'PARTNER/STAFF/GET/LIST',
  PARTNER_STAFF_TIME_TABLE = 'PARTNER/STAFF/TIME_TABLE',
}

/**
* Action Types
*/
interface CreatePartnerStaff {
  type: typeof PartnerStaffTypes.PARTNER_STAFF_CREATE,
  payload: PartnerStaff
}

interface DeletePartnerStaff {
  type: typeof PartnerStaffTypes.PARTNER_STAFF_DELETE,
  payload: number
}

interface GetPartnerStaffs {
  type: typeof PartnerStaffTypes.PARTNER_STAFF_GET_LIST,
  payload: PartnerStaff[]
}

interface SetTimeTableToPartnerStaff {
  type: typeof PartnerStaffTypes.PARTNER_STAFF_TIME_TABLE,
  payload: PartnerStaff
}

export type PartnerStaffActionTypes = (
  AlertActionTypes | CreatePartnerStaff | DeletePartnerStaff | GetPartnerStaffs | SetTimeTableToPartnerStaff
)
